import { IWidget } from 'core-components/sitebuilder/models/IWidget'

const initialData: IWidget = {
  i: '',
  x: 0,
  y: 0,
  w: 1,
  h: 1,
  scale: 100,
  title: '',
  description: '',
  content: '',
  src: '',
  type: 'Static',
  viewModel: '',
  createdAt: '',
  createdBy: '',
  styleSettings: {
    margins: '',
    paddings: '',
    border: '',
    borderRadius: '',
    backgroundColor: '',
    headerColor: '',
  },
  hideHeader: true,
  allowWindowMode: true,
  isScalable: false,
  autoHeight: false,
  minH: 0,
  group: '',
  roleIds: [],
  roles: [],
  isNew: false,
  routes: [],
  settings: {},
}

export const createWidget = (data?: Partial<IWidget>): IWidget => {
  const result = { ...initialData, ...data }
  if (result.minW && result.w < result.minW) {
    result.w = result.minW
  }
  if (result.minH && result.h < result.minH) {
    result.h = result.minH
  }
  return result
}
